import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import {initialize} from '../helpers/general'

Vue.use(VueRouter)
	let routes = [
		{
			// will match everything
			path: '*',
			component: () => import('../views/404.vue'),
		},
		{
			path: '/',
			name: 'Home',
			redirect: '/ingresar',
		},
		{
			path: '/recuperar-clave',
			name: 'RecuperarClave',
			component: () => import('../components/Password/RecuperarClave.vue'),
		},
		{
			path: '/reestablecer-clave',
			name: 'ReestablecerClave',
			component: () => import('../components/Password/ReestablecerClave.vue'),
		},
		{
			path: '/change-password',
			name: 'ChangePassword',
			layout: 'dashboard',
			meta: {
				requiresAuth: true
			},
			component: () => import('../views/ChangePassword.vue'),
		},
		{
			path: '/gestion-wifi',
			name: 'GestionWifi',
			layout: 'dashboard',
			meta: {
				requiresAuth: true, superAdmin: true
			},
			component: () => import('../views/GestionWifi.vue'),
		},
		{
			path: '/inicio',
			name: 'Inicio',
			layout: 'dashboard',
			meta: {
				requiresAuth: true
			},
			component: () => import('../views/Inicio.vue'),
		},
		{
			path: '/inicio-fullscreen',
			name: 'Inicio-Fullscreen',
			component: () => import('@/views/FullScreen.vue')
		},
		{
			path: '/inicio-con-mapa',
			name: 'InicioConMapa',
			layout: 'dashboard',
			meta: {
				requiresAuth: true
			},
			component: () => import('@/views/InicioConMapa.vue')
		},
		{
			path: '/departamentos/:id',
			name: 'Departamento',
			layout: 'dashboard',
			meta: {
				requiresAuth: true
			},
			component: () => import('../components/Sedes/Departamento.vue'),
		},
		{
			path: '/monteria',
			name: 'Monteria',
			layout: 'dashboard',
			meta: {
				requiresAuth: true
			},
			component: () => import('../components/Mapas/Monteria.vue'),
		},
		{
			path: '/campus-universitario',
			name: 'CampusUniversitario',
			layout: 'dashboard',
			meta: {
				requiresAuth: true
			},
			component: () => import('../components/Mapas/SedeCampusUniversitario.vue'),
		},
		{
			path: '/covenas',
			name: 'Covenas',
			layout: 'dashboard',
			meta: {
				requiresAuth: true
			},
			component: () => import('../components/Mapas/Covenas.vue'),
		},
		{
			path: '/sedes',
			name: 'Sedes',
			layout: 'dashboard',
			meta: {
				requiresAuth: true
			},
			component: () => import('../views/Sedes.vue'),
		},
		{
			path: '/sedes/:id',
			name: 'MostrarSede',
			layout: 'dashboard',
			meta: {
				requiresAuth: true
			},
			component: () => import('../components/Sedes/List.vue'),
		},
		{
			path: '/agregar-sede',
			name: 'AgregarSede',
			layout: 'dashboard',
			meta: {
				requiresAuth: true
			},
			component: () => import('../components/Sedes/Create.vue'),
		},
		{
			path: '/bloques/:nombre/:id',
			name: 'Bloques',
			layout: 'dashboard',
			meta: {
				requiresAuth: true
			},
			component: () => import('../views/Bloques.vue'),
		},
		{
			path: '/mapa-bloques/:id/:municipio',
			name: 'MapaBloques',
			layout: 'dashboard',
			// layout: 'dashboard',
			meta: {
				requiresAuth: true
			},
			component: () => import('../components/Bloques/List.vue'),
		},
		{
			path: '/unidades/:id',
			// path: '/unidades/:sede_id/:sede/:bloque/:id',
			name: 'Unidades',
			layout: 'dashboard',
			meta: {
				requiresAuth: true
			},
			component: () => import('../views/Unidades.vue'),
		},
		{
			path: '/ver-unidad/:id',
			// path: '/ver-unidad/:sede_id/:sede/:bloque/:bloque_id/:id',
			name: 'VerUnidad',
			// layout: 'dashboard',
			meta: {
				requiresAuth: true
			},
			props: true,
			component: () => import('../components/Unidades/Show.vue'),
		},
		{
			path: '/crear-unidad/:sede_id/:bloque_id/',
			name: 'CrearUnidad',
			// layout: 'dashboard',
			meta: {
				requiresAuth: true
			},
			props: true,
			component: () => import('../components/Unidades/Create.vue'),
		},
		{
			path: '/editar-unidad/:id/:sede_id/:bloque_id',
			name: 'EditarUnidad',
			// layout: 'dashboard',
			meta: {
				requiresAuth: true
			},
			props: true,
			component: () => import('../components/Unidades/Create.vue'),
		},
		{
			path: '/layout',
			name: 'Layout',
			layout: "dashboard",
			component: () => import('../views/Layout.vue'),
		},
		{
			path: '/ingresar',
			name: 'Ingresar',
			component: () => import('../views/Sign-In.vue'),
		},
		{
			path: '/crear-novedad/:cbi',
			name: 'CrearNovedad',
			// layout: 'dashboard',
			meta: {
				requiresAuth: true
			},
			component: () => import('../components/Novedades/Create.vue'),
		},
		{
			path: '/Profile',
			name: 'Profile',
			layout: "dashboard",
			meta: {
				layoutClass: 'layout-profile',
				requiresAuth: true,
				superAdmin: true
			},
			component: () => import('../views/Profile.vue'),
		},
		{
			path: '/users',
			name: 'Usuarios',
			layout: 'dashboard',
			meta: {
				requiresAuth: true, superAdmin: true
			},
			component: () => import('../components/Users/Index.vue'),
		},
		{
			path: '/gestion-cbi',
			name: 'GestionCBI',
			layout: 'dashboard',
			meta: {
				requiresAuth: true, superAdmin: true
			},
			props: true,
			component: () => import('../views/GestionCBI.vue'),
		},
	]



// Adding layout property from each route to the meta
// object so it can be accessed later.
function addLayoutToRoute( route, parentLayout = "default" )
{
	route.meta = route.meta || {} ;
	route.meta.layout = route.layout || parentLayout ;
	
	if( route.children )
	{
		route.children = route.children.map( ( childRoute ) => addLayoutToRoute( childRoute, route.meta.layout ) ) ;
	}
	return route ;
}

routes = routes.map( ( route ) => addLayoutToRoute( route ) ) ;

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior (to, from, savedPosition) {
		if ( to.hash ) {
			return {
				selector: to.hash,
				behavior: 'smooth',
			}
		}
		return {
			x: 0,
			y: 0,
			behavior: 'smooth',
		}
	}
})

initialize(store, router);

export default router
